export default "80a2d6844ca190c2.woff2"